import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-diario-accordion',
  standalone: true,
  imports: [],
  templateUrl: './diario-accordion.component.html',
  styleUrl: './diario-accordion.component.css'
})
export class DiarioAccordionComponent {
  @Input() titulo!: string;
  @Input() possuiConteudo = false;
  isOpen = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
